import React from 'react';
import ContainerFlex from '~/components/containerFlex';

import CardViewSelect, { IOption } from '~/components/cartViewSelect';

export type TCampaingCriteriosSegmentacaoProps = {
  selected: IOption[];
  setSelected: React.Dispatch<React.SetStateAction<IOption[]>>;
};

const dataTypes: IOption[] = [
  { id: 1, value: 'LIMITE_DISPONIVEL', label: 'Limite Disponivel' },
  { id: 2, value: 'BAIRRO', label: 'Endereço' },
  { id: 3, value: 'STATUS_CARTAO', label: 'Status do cartao' },
];

const CampaingCriteriosSegmentacao = ({
  selected,
  setSelected,
}: TCampaingCriteriosSegmentacaoProps): JSX.Element => {
  return (
    <ContainerFlex
      color="#f5f5f5"
      maxWidth={50}
      padding={15}
      borderRadius={8}
      marginTop={10}
    >
      <ContainerFlex>
        <CardViewSelect
          options={dataTypes}
          placeholder="Selecione opções"
          label="Pesquisa por tipo"
          value={selected}
          onChange={setSelected}
          btnClear={true}
          showChips={true}
        />
      </ContainerFlex>
    </ContainerFlex>
  );
};

export default CampaingCriteriosSegmentacao;
